import { VStack, Heading, ArrowCta } from 'components/ui';
import { useFormData } from '../../../utils/formReducer.js';
import Sex from './Sex';
import Gender from './Gender';
import { Ethnicity } from './Ethnicity';
import { StickyCtaLayout } from '../../ui/StickyCtaLayout';
import HeaderNav from '../../HeaderNav/HeaderNav';
import { FORM_VIEW, FormViews } from '../constants';

export const Identity = ({ onNext }) => {
  const { state: formData, dispatch } = useFormData();

  return (
    <StickyCtaLayout
      actionArea={
        <ArrowCta
          disabled={!formData.sex || !formData.gender || !formData.race}
          onClick={onNext}
          data-testid="onboarding-sex-gender-button"
        >
          Next
        </ArrowCta>
      }
      header={
        <HeaderNav
          screenName={FORM_VIEW[FormViews.questionIdentity].trackingLabel}
          showWhatIsAybleModal
        />
      }
      maxWidth="formWidth"
    >
      <VStack gap="34px" w="100%">
        <Heading textStyle="heading.h2">How do you identify?</Heading>

        <Sex dispatch={dispatch} formData={formData} />
        <Gender dispatch={dispatch} formData={formData} />
        <Ethnicity dispatch={dispatch} formData={formData} />
      </VStack>
    </StickyCtaLayout>
  );
};

export default Identity;
